import { modalsStateSetDictKeys as reportModalsStateSetDictKeys } from 'components/ReportList/config';
import { modalsStateSetDictKeys as cjModalsStateSetDictKeys } from 'components/CustomerJourneyList/config';
// Import Constants
import { l } from 'constants/common';
// Import Enums
import { PermissionEnum, ObjectTypeIdsEnum } from 'enums';

export const ObjectTypeIcons = {
    [ObjectTypeIdsEnum.Segment]: 'bc-icon-segment',
    [ObjectTypeIdsEnum.Template]: 'bc-icon-template',
    [ObjectTypeIdsEnum.Campaign]: 'bc-icon-campaign',
    [ObjectTypeIdsEnum.RealtimePromotion]: 'bc-icon-customer-journey',
    [ObjectTypeIdsEnum.Report]: 'bc-icon-reports',
};

export const getObjectTypes = (t) => [
    {
        name: t(l.Segment),
        id: ObjectTypeIdsEnum.Segment,
        value: String(ObjectTypeIdsEnum.Segment),
        icon: ObjectTypeIcons[ObjectTypeIdsEnum.Segment],
        checked: false,
        permissions: [],
    },
    {
        name: t(l.Template),
        id: ObjectTypeIdsEnum.Template,
        value: String(ObjectTypeIdsEnum.Template),
        icon: ObjectTypeIcons[ObjectTypeIdsEnum.Template],
        checked: false,
        permissions: [],
    },
    {
        name: t(l.Campaign),
        id: ObjectTypeIdsEnum.Campaign,
        value: String(ObjectTypeIdsEnum.Campaign),
        icon: ObjectTypeIcons[ObjectTypeIdsEnum.Campaign],
        checked: false,
        permissions: [],
    },
    {
        name: t(l.RealtimePromotion),
        id: ObjectTypeIdsEnum.RealtimePromotion,
        value: String(ObjectTypeIdsEnum.RealtimePromotion),
        icon: ObjectTypeIcons[ObjectTypeIdsEnum.RealtimePromotion],
        checked: false,
        permissions: [PermissionEnum.ViewWorkflow],
    },
    {
        name: t(l.Report),
        id: ObjectTypeIdsEnum.Report,
        value: String(ObjectTypeIdsEnum.Report),
        icon: ObjectTypeIcons[ObjectTypeIdsEnum.Report],
        checked: false,
        permissions: [],
    },
];

export const modalsStateSetDictKeys = {
    ...reportModalsStateSetDictKeys,
    ...cjModalsStateSetDictKeys,
};

export const searchActionKeys = {
    view: 'view',
    info: 'info',
};

export const globalSearchObjectKeys = {
    segment: 'segment',
    template: 'template',
    realtimePromotion: 'realtimePromotion',
    campaign: 'campaign',
    report: 'report',
};
